var React = require('react');

function ArrowTopInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icon-scrolltop"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Services","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"icon-scrolltop","fill":"#fff","fillRule":"nonzero"},React.createElement("polyline",{"id":"Path","points":"6.91369998 13.63267 5.30629999 13.63267 5.30629999 3.56729999 1.55288 7.31789998 0.410779999 6.17861998 6.10999998 0.485039999 11.8064 6.18143998 10.66712 7.32071998 6.91369998 3.56729999"})))]);
}

ArrowTopInline.defaultProps = {"width":"12px","height":"14px","viewBox":"0 0 12 14","version":"1.1"};

module.exports = ArrowTopInline;

ArrowTopInline.default = ArrowTopInline;
